import {Injectable} from '@angular/core';
import {
    CreateTransactionRuleDialogComponent
} from "../components/dialogs/create-transaction-rule-dialog/create-transaction-rule-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {TransactionsRulesService} from './transactionsRules.service';
import {PermissionOptions} from '@users/models/user.interface';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TransactionRule} from "../models/transactionRule.interface";
import {
    DuplicateRuleDialogComponent
} from "../components/dialogs/duplicate-rule-dialog/duplicate-rule-dialog.component";

@Injectable()
export class TransactionsRulesDialogsService {

    constructor(private dialog: MatDialog, private service: TransactionsRulesService, private snackbar: MatSnackBar) {
    }

    openCreateDialog(data?: any) {

        if (!this.service.authService.checkPermission(PermissionOptions.BOOKINGS_WRITE)) {
            const msg = "Zugriff verweigert: Sie verfügen nicht über die erforderliche Berechtigung 'Buchhaltung - SCHREIBEN', um Regeln zu erstellen oder zu bearbeiten. Bitte kontaktieren Sie Ihren Admin-Benutzer.";
            this.snackbar.open(msg, 'OK', {duration: 10000});
            return;
        }

        this.dialog.open(CreateTransactionRuleDialogComponent, {
            autoFocus: false,
            disableClose: true,
            maxHeight: '90vh',
            data,
            panelClass: 'fuse-confirmation-dialog-panel',
        });
    }

    openDuplicateDialog(data: TransactionRule) {

        if (!this.service.authService.checkPermission(PermissionOptions.BOOKINGS_WRITE)) {
            const msg = "Zugriff verweigert: Sie verfügen nicht über die erforderliche Berechtigung 'Buchhaltung - SCHREIBEN', um Regeln zu erstellen oder zu bearbeiten. Bitte kontaktieren Sie Ihren Admin-Benutzer.";
            this.snackbar.open(msg, 'OK', {duration: 10000});
            return;
        }

        this.dialog.open(DuplicateRuleDialogComponent, {
            autoFocus: false,
            disableClose: true,
            maxHeight: '90vh',
            data,
            panelClass: 'fuse-confirmation-dialog-panel',
        });
    }
}
